import React from 'react'
import {
  BaseModal,
  BaseModalProps,
} from '@/components/modals/base-modal/base-modal'

interface Props extends BaseModalProps {
  onSubmit: (data: any) => void
}

const FormModal: React.FC<Props> = ({ onSubmit, ...props }) => {
  const submit = (event: any) => {
    event.preventDefault()
    const form = event.currentTarget
    const formData = new FormData(form)
    const data = Object.fromEntries(formData.entries())
    onSubmit(data)
  }

  return (
    <BaseModal
      PaperProps={{
        ...props.PaperProps,
        onSubmit: submit,
        component: 'form',
      }}
      {...props}
    />
  )
}

export default FormModal
